__turbopack_context__.v({
  "carousel": "ItineraryListCarouselSection-module__EFBohG__carousel",
  "ctaContainer": "ItineraryListCarouselSection-module__EFBohG__ctaContainer",
  "title": "ItineraryListCarouselSection-module__EFBohG__title",
  "tripDesignerCardMobile": "ItineraryListCarouselSection-module__EFBohG__tripDesignerCardMobile",
});
